<template>
  <v-dialog v-model="dialogGetPassword" persistant  width="600">
    <v-toolbar card style="background: #1a222c !important;">
      <v-toolbar-title class="white--text"></v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn dark icon flat @click="dialogGetPassword = false"> -->
              <v-btn dark icon flat @click="closeDialogGetpassword()">
        <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card>
      <div class="pt-4 pb-4 pr-4 pl-4">
        <span style="font-size:18px; font-weight:bold ;" >{{$t('File.textRequirePassword')}}</span>
        <br/>
            <v-text-field
              class="mt-2"
              v-model="passwordFile"
              solo
              :label="$t('File.passwordFile')"
              clearable
              append-icon="search"
            ></v-text-field>
            <v-layout justify-end>
              <v-btn outline round style="background-color:white; color:#2562af; border-color:#2562af;" @click="cancle()">{{$t('AnswerQuestion.cancel')}}</v-btn>
              <v-btn round :disabled="passwordFile == '' || passwordFile == null ? true : false" style="background-color:#2562af; color:white;"  @click="submitPassword()" :loading="progressBtn">{{$t('AnswerQuestion.ok')}}</v-btn>
            </v-layout>
                <ShowPDFDialog :dialogshowfile="dialogshowfile" :DetailFile="DetailFile" @closeDialogShowFile="closeDialogShowFile"/>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ShowPDFDialog from '@/components/chat/dialog/ShowPDFDialog'
  export default {
    components:{
      ShowPDFDialog
    },
    props:{
      dialogGetPassword: Boolean,
      DetailFile: Object
    },
    data () {
      return {
        progressBtn:false,
        passwordFile: '',
        dialogshowfile: false

      }
    },
    methods:{
      submitPassword() {
        this.tokenmsg_file_pass = this.DetailFile.tokenmessage
        this.name_file_pass = this.DetailFile.file_name
        // this.tokenmessage
        this.progressBtn = true
        var body = {
            tokenmessage: this.tokenmsg_file_pass,
            password: this.passwordFile
        }
        // console.log(process.env.check_password + 'api/v1/check-password' , body)
            this.axios.post(process.env.check_password + '/api/v1/check-password' , body).then((response) => {
            if(response.status == '200'){
                this.progressBtn = false
                if(response.data.message == 'wrong password'){
                this.$swal(this.$t('File.wrongPassword'), '' , 'error')
                }else if(response.data.status == 'success'){
                var message = response.data.path
                var filename = response.data.path.split('.')
                // this.dialogGetPassword = false
                this.closeDialogGetpassword()
                this.passwordFile = ''
                this.axios.get(response.data.path, {
                    responseType: 'blob'
                }).then((response) => {
                    if(filename[filename.length - 1] == 'pdf'){
                    // message
                    this.DetailFile.message = message
                    this.dialogshowfile = true

                    }else{
                        const url = window.URL.createObjectURL(new Blob([response.data]))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', `${this.name_file_pass}.${filename[filename.length - 1]}`)
                        document.body.appendChild(link)
                        link.click()

                    }
                })

                }else{
                   this.$swal(this.$t('Alert.Fail.default.somethingWrong'), '' , 'error')
                   this.progressBtn = false
                }
              }
            }).catch((err) =>{
                // console.log(err)
                // console.log(err.response)
                this.$swal(this.$t('Alert.Fail.default.somethingWrong'), '' , 'error')
                this.progressBtn = false
            })
        // console.log('ddddddddddddddddddddd')
      },
      closeDialogGetpassword(){
        this.passwordFile = ''
        this.$emit('closeDialogpassword' , false)
      },
      cancle() {
        this.passwordFile = ''
        this.$emit('closeDialogpassword' , false)
      },
      closeDialogShowFile (value) {
        this.dialogshowfile = value
      },
    }
  }
  </script>

<style scoped>
>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 20px;
    background: #fff;
}

>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
    border: #ccc solid 2px !important ;
    box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/dialogGetPassword.vue